import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class Base {
    static init(props) {
        App.log('BASE.INIT', App.LOG.FETCH, props);

        const body = {
            methodName: [
                'BloodGroups',
                'ProductTypes',
                'AllSections',
                'HospitalSections',
                'AllHospitals',
                'HospitalReturnReasons',
                'SectionReturnReasons',
                'DestroyedReasons',
                'SurgeryTypes',
                'Genders',
                'ProvinceCities',
                'PatientDiagnostics',
                'Roles',
                'Docters',
                'ProductMaintanceConditions'
            ],
            hospitalId: props.hospitalId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.INIT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        result = result?.objList[0];
                        const list = {};

                        list['bloodGroups'] = result?.bloodGroups || [];
                        list['bloodGroupsById'] = {}
                        list['productTypes'] = result?.productTypes || [];
                        list['doctors'] = (result?.docters || []).map(item => ({
                            id: item.docterId,
                            text: item.docterFullName,
                            data: item
                        }));
                        list['productTypesById'] = {};
                        list['allSections'] = result?.allSections || [];
                        list['hospitalSections'] = result?.hospitalSections || [];
                        list['allHospitals'] = result?.hospitals || [];
                        list['hospitalReturnReasons'] = result?.hospitalReturnReasons || [];
                        list['sectionReturnReasons'] = result?.sectionReturnReasons || [];
                        list['destroyedReasons'] = result?.destroyedReasons || [];
                        list['surgeryTypes'] = result?.surgeryTypes || [];
                        list['genders'] = result?.genders || [];
                        list['provinceCities'] = result?.provinceCities || [];
                        list['patientDiagnostics'] = result?.patientDiagnostics || [];
                        list['roles'] = result?.roles || [];
                        list['productMaintenanceConditions'] = result?.productMaintanceConditions || [];

                        for (const item of result?.bloodGroups)
                            list.bloodGroupsById[item.id] = item;

                        for (const item of result?.productTypes)
                            list.productTypesById[item.id] = item;

                        resolve(list);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export default Base